<template>
  <el-row
    v-loading="isLoading"
    :gutter="15"
  >
    <el-col :md="6">
      <List
        v-if="enquiries.length"
        :enquiries="enquiries"
        @change="change"
      />
    </el-col>
    <el-col :md="18">
      <Details
        v-if="enquiries.length"
        :enquiry="enquiries[activeEnquiry]"
        :consignment="consignment"
      />
    </el-col>
    <Empty
      v-if="!enquiries.length && !isLoading"
      description="There are no enquiries for this consignment."
    />
  </el-row>
</template>
<script>
import List from '@/components/Application/Freight/Consignments/Enquiries/List'
import Details from '@/components/Application/Freight/Consignments/Enquiries/Details'
import Request, { GET } from '@/plugins/sdk/Request'
import CreateEnquiryDialog from '@/components/Application/Freight/Consignments/Enquiries/CreateDialog'
import Vue from 'vue'
import Empty from '@/components/Empty'

export default {
  components: {
    List,
    Details,
    Empty
  },
  data () {
    return {
      breadcrumb: {
        name: 'Enquiries',
        route: { name: 'freight-consignments-v3-consignment-enquiries', params: { consignmentId: this.$route.params.consignmentId } }
      },
      actions: [
        {
          hidden: false,
          name: 'Create',
          icon: ['fal', 'plus'],
          event: () => {
            this.createEnquiry(this.consignment)
          }
        }
      ],
      consignment: null,
      isLoading: true,
      enquiries: [],
      activeEnquiry: 0,
      enquiryCreateDialogInstance: undefined,
      enquiryCreateDialogVisible: false
    }
  },
  created () {
    this.loadConsignment()
  },
  methods: {
    change (val) {
      this.activeEnquiry = val
    },
    async loadConsignment () {
      this
        .$sdk
        .consignment
        .read(this.$route.params.consignmentId, request => {
          request.include = [
            'account',
            'carrier',
            'service',
            'team.account',
            'items',
            'trackings.scan.proof_of_delivery',
            'trackings.level',
            'trackings.level.type',
            'trackings.consignment_item',
            'pickup',
            'items',
            'edi',
            'enquiries'
          ]
        })
        .then(res => { this.consignment = res; this.loadEnquiries() })
        .finally(() => { this.isLoading = false })
    },
    createEnquiry (consignment) {
      const EnquiryCreateDialogClass = Vue.extend(CreateEnquiryDialog)

      this.enquiryCreateDialogInstance = new EnquiryCreateDialogClass({
        propsData: {
          consignment
        }
      })

      this
        .enquiryCreateDialogInstance
        .$on('destroy', () => {
          this.enquiryCreateDialogVisible = false
          this.loadConsignment()
        })

      this
        .enquiryCreateDialogInstance
        .$mount()

      this
        .$root
        .$el
        .appendChild(this.enquiryCreateDialogInstance.$el)

      this.enquiryCreateDialogVisible = true
    },
    async loadEnquiries () {
      this.consignment.enquiries.forEach(async element => {
        const request = await (Object.assign(new Request(), {
          method: GET,
          _pathname: 'freshdesk/ticket/' + element
        })).build()

        const response = await fetch(request)

        this.enquiries.push(await response.json())
      })
    },
    setActiveEnquiry (index) {
      this.activeEnquiry = index
    }
  }
}
</script>
